<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="id" :label="$t('attributes.id')">
              <b-field :type="idStatus">
                <b-input
                  v-model="form.id"
                  name="id"
                  expanded
                  :loading="idChecking"
                  :disabled="isEditing"
                  @blur="checkId"
                >
                </b-input>
              </b-field>
            </form-group>
            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>
            <form-group horizontal name="tel" :label="$t('attributes.tel')">
              <b-input
                v-model="form.tel"
                name="tel"
                :placeholder="$t('message.please_input') + $t('attributes.tel')"
                expanded
              >
              </b-input>
            </form-group>
            <form-group horizontal name="fax" :label="$t('attributes.fax')">
              <b-input
                v-model="form.fax"
                name="fax"
                :placeholder="$t('message.please_input') + $t('attributes.fax')"
                expanded
              >
              </b-input>
            </form-group>
            <form-group horizontal name="email" :label="$t('attributes.email')">
              <b-input
                v-model="form.email"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.email')
                "
                expanded
              >
              </b-input>
            </form-group>
            <form-group
              horizontal
              name="address"
              :label="$t('attributes.address')"
            >
              <b-input
                v-model="form.address"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.address')
                "
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button
            :loading="loading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="loading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              this.isEditing ? $t('attributes.update') : $t('attributes.add')
            }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { COMPANIES_API } from '@/utils/apis'

export default {
  name: 'CompanyForm',
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      idChecking: false,
      labelPosition: 'on-border',
      isEditing: this.company.id != null,
      form: this.extractFormValues(this.company),

      idStatus: '',
      sortOptions: [...Array(20).keys()].map(i => i + 1)
    }
  },
  validations: {
    form: {
      id: { required, maxLength: maxLength(100) },
      name: { required, maxLength: maxLength(50) },
      tel: { required, maxLength: maxLength(50) },
      fax: { required, maxLength: maxLength(50) },
      sort: { required },
      status: { required },
      email: { maxLength: maxLength(200) },
      address: { maxLength: maxLength(150) }
    }
  },
  computed: {
    formTitle() {
      let title = this.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.company')

      return title
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        tel: data.tel,
        fax: data.fax,
        sort: data.sort,
        status: data.status,
        email: data.email,
        address: data.address
      }
    },
    async checkId() {
      if (!this.isEditing && this.form.id === null) {
        this.idStatus = ''
        return
      } else if (this.form.id === '') {
        this.idStatus = ''
        return
      }
      try {
        const api = `${COMPANIES_API}/${this.form.id}/check`

        this.idChecking = true
        const res = await this.axios.get(api)
        const result = res.data.data
        if (result) {
          this.idStatus = 'is-success'
        } else {
          this.idStatus = 'is-danger'
        }
      } catch (e) {
        this.idStatus = ''
      } finally {
        this.idChecking = false
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      if (!this.isEditing && this.idStatus === 'is-danger') {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
